import { UsersIcon } from "@/icons";
import { cn } from "@/lib/cn";
import { Flex, Switch } from "antd";
import { useGetAllEmployeesQuery } from "@/app/features/employee/emp-dashboard/emp-dashboard.api";
import IMAGES from "@/assets/images";
import CustomDrawer from "@/components/CustomDrawer";
import CustomImage from "@/components/CustomImage";
import type { CustomModalProps } from "@/components/CustomModal";
import WithLoader from "@/components/WithLoader";

type Props = CustomModalProps & {
  data: any;
};

const DepartmentUsers = ({ data, open, handleClose }: Props) => {
  const {
    data: employees,
    isLoading,
    isFetching,
  } = useGetAllEmployeesQuery(
    { params: { department_id: data?.id, page: 0, limit: 0 } },
    { skip: !open || !data?.id },
  );

  return (
    <CustomDrawer
      width={850}
      open={open}
      onClose={handleClose}
      title={`${data?.name}`}
    >
      <div className="grid grid-cols-2 gap-6 border-b border-b-theme-slate-700 pb-4">
        <div>
          <h5 className="text-base mb-2">Department name </h5>
          <h3 className="text-lg text-white font-medium">{data?.name}</h3>
        </div>
        <div>
          <h5 className="text-base mb-2">Status</h5>
          <Switch
            className="custom-switch"
            checked={data?.status === "active"}
          />
        </div>
      </div>
      <WithLoader
        isLoading={isLoading || isFetching}
        className={cn(
          "rounded-lg",
          (isLoading || isFetching) && "h-[calc(100vh_-_213px)] mt-7",
        )}
      >
        {employees?.data?.data && employees?.data?.data?.length > 0 ? (
          <div className="my-7 grid grid-cols-2 md:grid-cols-4 gap-3">
            {employees?.data?.data?.map((user) => (
              <Flex
                key={user?.id}
                gap={10}
                className="p-2.5 rounded-lg bg-theme-slate-800"
              >
                <CustomImage
                  alt="User"
                  width={25}
                  height={25}
                  src={IMAGES.avatar}
                  className="rounded-full"
                />
                <div>
                  <span className="block text-xs">ID #{user?.employee_id}</span>
                  <span className="block text-base font-medium">
                    {user?.name}
                  </span>
                  <span className="block text-xs font-medium">
                    {user?.designation?.name}
                  </span>
                </div>
              </Flex>
            ))}
          </div>
        ) : (
          <div className="my-7 flex flex-col items-center justify-center py-12">
            <div className="mb-4 p-4 rounded-full bg-theme-slate-800">
              <UsersIcon size={40} className="text-theme-slate-400" />
            </div>
            <h3 className="text-lg font-medium text-white mb-2">
              No Users Found
            </h3>
            <p className="text-sm text-theme-slate-400 text-center max-w-sm">
              There are no employees assigned to this department yet.
            </p>
          </div>
        )}
      </WithLoader>
    </CustomDrawer>
  );
};

export default DepartmentUsers;
